import { createApp,ref } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "./assets/css/globe.css";


import "./utils/flexible";
import "./utils/china";
import utils from "./utils/common";
import dataV from '@jiaminghi/data-view'
import vue3videoPlay from 'vue3-video-play' // 引入组件
import 'vue3-video-play/dist/style.css' // 引入css
import 'animate.css';
import "echarts-liquidfill";
import BaiduMap from 'vue-baidu-map-3x'
// import { getRandomDate } from './utils/getRandomDate';
// app.use(vue3videoPlay) 
// import scroll from 'vue-seamless-scroll'
// Vue.use(scroll)



import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
const app = createApp(App);

 
async function getToken(state){
    // localStorage.setItem('AccessToken', 'at.dj3xvud05r8xkayd8qvksiofdc2pad3u-8z6jxva1gf-09utm1v-mwpsczrd0');
    axios
      .get("https://zhfarm.laicunwang.com/api/environment/getcamera11", {sign:"c4c6cff9b7ec6b87fa953f77ec7e624b"})
      .then((res) => {
          console.log(res.data.data.accessToken);
          // state.AccessToken = res.data.data.data.accessToken
          localStorage.setItem('AccessToken', res.data.data.accessToken);
        
      });
}
getToken()

const globalVariable = ref('https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img');
app.config.globalProperties.$globalVariable = globalVariable;

app.use(BaiduMap,{// ak 是在百度地图开发者平台申请
    ak:'D13xI9XvcWECLBL5mp8uRSGuAmdB6GXQ',
});
app.use(store);
app.use(dataV);
// app.use(scroll);
app.use(router);
app.use(ElementPlus)
app.use(vue3videoPlay)
app.config.globalProperties.$utils = utils;
// app.config.globalProperties.$getRandomDate = getRandomDate;
app.mount("#app");
